/**
 * @generated SignedSource<<34df96bb816f10199410fbd392b4c5b1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedCategoryTabs_creatorRootPage$data = {
  readonly verticalItems: ReadonlyArray<{
    readonly list: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorsResultContainer_items">;
    } | null> | null;
  } | null> | null;
  readonly verticals: ReadonlyArray<VerticalType | null> | null;
  readonly verticalsUriRef: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "SbSharedCategoryTabs_creatorRootPage";
};
export type SbSharedCategoryTabs_creatorRootPage$key = {
  readonly " $data"?: SbSharedCategoryTabs_creatorRootPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCategoryTabs_creatorRootPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCategoryTabs_creatorRootPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verticals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verticalsUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VerticalItems",
      "kind": "LinkedField",
      "name": "verticalItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "kind": "LinkedField",
          "name": "list",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedCreatorsResultContainer_items"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatorRootPage",
  "abstractKey": null
};

(node as any).hash = "038e48f2009035ec2ec7e6fb8a931a02";

export default node;
